import { render, staticRenderFns } from "./Protection.vue?vue&type=template&id=50333826&scoped=true";
import script from "./Protection.vue?vue&type=script&lang=js";
export * from "./Protection.vue?vue&type=script&lang=js";
import style0 from "./Protection.vue?vue&type=style&index=0&id=50333826&prod&scoped=true&lang=less";

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "50333826", null);
export default component.exports;